module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "weui-wepay-pay"
  }, [_c('div', {
    staticClass: "weui-wepay-pay__bd"
  }, [_c('div', {
    staticClass: "weui-wepay-pay__inner"
  }, [_c('h1', {
    staticClass: "weui-wepay-pay__title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-wepay-pay__inputs"
  }, [_c('strong', {
    staticClass: "weui-wepay-pay__strong",
    domProps: {
      "innerHTML": _vm._s(_vm.label || '￥')
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "weui-wepay-pay__input",
    attrs: {
      "type": "number",
      "placeholder": _vm.placeholder,
      "number": ""
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui-wepay-pay__intro"
  }, [_vm._t("description", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "weui-wepay-pay__ft"
  }, [_c('p', {
    staticClass: "weui-wepay-pay__info",
    domProps: {
      "innerHTML": _vm._s(_vm.info)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-wepay-pay__btn"
  }, [_vm._t("button")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aafc8732"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/wepay-input/index.vue
// module id = 546
// module chunks = 4